function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_146510",
  d: "M7.895,17.454H15.67a1.873,1.873,0,0,0,2.112-2.093V7.547A1.873,1.873,0,0,0,15.67,5.454H7.895A1.873,1.873,0,0,0,5.782,7.547v7.814A1.876,1.876,0,0,0,7.895,17.454Zm3.91-4.912a.557.557,0,0,1-.61-.6l-.09-3.2a.639.639,0,0,1,.693-.674.656.656,0,0,1,.7.681l-.1,3.2A.545.545,0,0,1,11.8,12.542Zm0,2.221a.74.74,0,1,1,.79-.738A.761.761,0,0,1,11.8,14.764Z",
  transform: "translate(-5.782 -5.454)",
  fill: "currentColor"
});

function SvgErrorRectangle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorRectangle);
export default __webpack_public_path__ + "static/media/error-rectangle.61806248.svg";
export { ForwardRef as ReactComponent };